import * as React from "react";
import { Navigate } from "react-router";

export type ProtectedRouteProps = {
  authenticationPath: string;
  outlet: React.JSX.Element;
};

export default function ProtectedRoute({
  authenticationPath,
  outlet,
}: ProtectedRouteProps) {
  const isAuthenticated = !!localStorage.getItem("access_token");

  return isAuthenticated ? (
    outlet
  ) : (
    <Navigate to={authenticationPath} replace />
  );
}
